export { default, CommonAccordionsWrapper } from './CommonAccordion'
